import React from 'react';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import TradeMobileController from './mobile/TradeMobileController';
import DTTradeController from './desktop/DTTradeController';
const TradeController = () => {
  const isMobile = useIsMobile();
  return <>{isMobile ? <TradeMobileController /> : <DTTradeController />}</>;
};
export default TradeController;